import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import SearchTracking from 'utils/search-tracking';
import SegmentUtils from 'utils/segment';
import getParkingType from '../utils/parking-type';
import getFilteredSearchResults from '../utils/filtered-search-results';
import getUserLocation from '../utils/user-location';

export default function trackProductsSearched({
    city: {display_name: cityName, slug: citySlug, state},
    destination: {
        id: destinationId,
        title: destinationName,
        google_places: destinationGooglePlaces,
        airport,
    },
    event: {id: eventId, title: eventName},
    destinationTitle,
    searchRequest: {
        monthly,
        referrer,
        search_string: searchQuery,
        latitude,
        longitude,
        starts,
        ends,
    },
    activeAmenities,
    spots = [],
    searchAPIVersion,
}) {
    const isEvent = Boolean(eventId);
    const {
        sessionUUID,
        searchUUID,
        action: trackingAction,
    } = SearchTracking.getValues();
    const parkingType = getParkingType({
        isMonthly: monthly,
        isAirport: airport,
        isEvent,
    });
    const searchSource = !isEmpty(referrer) ? referrer : 'map';
    const googlePlaceId = get(
        destinationGooglePlaces,
        '0.google_places_place_id'
    );
    const googlePlaceName = get(
        destinationGooglePlaces,
        '0.google_places_name'
    );
    const unfilteredSpots = getFilteredSearchResults({
        spots,
        airport,
    });
    const properties = {
        'search query': searchQuery || destinationTitle, // MARKED FOR DEPRECATION: query will be used moving forward
        query: searchQuery || destinationTitle,
        'search city': cityName, // MARKED FOR DEPRECATION: city will be used moving forward
        city: citySlug,
        state,
        'session id': sessionUUID, // MARKED FOR DEPRECATION: session_id will be used moving forward
        session_id: sessionUUID,
        'search id': searchUUID, // MARKED FOR DEPRECATION: search_id will be used moving forward
        search_id: searchUUID,
        'parking type': parkingType, // MARKED FOR DEPRECATION: parking_type will be used moving forward
        parking_type: parkingType,
        'search type': trackingAction, // MARKED FOR DEPRECATION: action_type will be used moving forward
        action_type: trackingAction,
        'search source': searchSource, // MARKED FOR DEPRECATION: search_source will be used moving forward
        search_source: searchSource,
        'number of filters applied': activeAmenities.length,
        'filters selected': activeAmenities.join(),
        search_api_version: searchAPIVersion,
        'search start time': moment(starts).toISOString(), // MARKED FOR DEPRECATION: search_start_time_utc will be used moving forward
        search_start_time_utc: moment(starts).toISOString(),
        'search end time': monthly ? null : moment(ends).toISOString(), // MARKED FOR DEPRECATION: search_end_time_utc will be used moving forward
        search_end_time_utc: monthly ? null : moment(ends).toISOString(),
        map_center: {
            latitude,
            longitude,
        },
        destination_id: destinationId,
        destination_name: destinationName,
        event_id: eventId,
        event_name: eventName,
        google_places_name: googlePlaceName,
        google_places_place_id: googlePlaceId,
        ...getUserLocation(),
        ...(airport && {
            'airport code search': airport.iata_code, // MARKED FOR DEPRECATION: airport_code will be used moving forward
            airport_code: airport.iata_code,
        }),
        top_search_results_list: unfilteredSpots.map(({spotId, tag}) => {
            return {
                facility_id: spotId,
                tag,
            };
        }),
    };

    SegmentUtils.track({
        event: 'Products Searched',
        properties,
        additionalOptions: {
            context: {
                protocols: {
                    event_version: 4,
                },
            },
        },
    });
}
